import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PriceInputWithEarnings from '../../../../../../DollarPriceInput/variants/PriceInputWithEarnings';
export const PLACEHOLDER_FOLDER_PRICE = 10;
const PriceField = ({ name = 'price' })=>{
    var _errors_name;
    const { t } = useTranslation();
    const { control, errors } = useFormContext();
    const errorMessage = (_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message;
    const _useController = useController({
        name,
        control
    }), { field: { ref } } = _useController, fieldProps = _object_without_properties(_useController.field, [
        "ref"
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PriceInputWithEarnings, _object_spread_props(_object_spread({}, fieldProps), {
        label: t('mediapopup.gallections.a11y.priceInputLabel'),
        error: errorMessage,
        placeholder: PLACEHOLDER_FOLDER_PRICE,
        ref: ref,
        productType: "gallery"
    })));
};
PriceField.displayName = 'PriceField';
export default PriceField;

//# sourceMappingURL=PriceField.js.map